
 export const USER = "USER";


 
/**
 *
 * @param {*} id
 * @returns
 */
 

 


export const user = (value) => {
  return {
    type: USER,
    payload: value,
  };
};


